let timeout;

window.dataLayer = window.dataLayer || [];

export const trackPushState = (ignore) => {
  window.history.pushState = new Proxy(window.history.pushState, {
    apply: (target, thisArg, argArray) => {
      if (!ignore || ignore.indexOf(argArray[2]) === -1) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          window.dataLayer.push(["pageView"]);
          if (window.analytics) {
            window.analytics.page();
          }
        }, 100);
      }
      return target.apply(thisArg, argArray);
    },
  });
};
